import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "bg-card rounded-lg shadow p-6 max-w-2xl" }
const _hoisted_3 = { class: "flex items-center mb-8" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "h-24 w-24 rounded-full bg-primary/20 flex items-center justify-center overflow-hidden" }
const _hoisted_6 = {
  key: 0,
  class: "text-4xl font-semibold text-primary"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-6" }
const _hoisted_9 = { class: "text-xl font-semibold" }
const _hoisted_10 = { class: "text-muted-foreground" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-6 md:grid-cols-2" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "pt-4 border-t border-border"
}
const _hoisted_15 = {
  key: 0,
  class: "p-3 bg-green-100 text-green-700 rounded-md mb-3"
}
const _hoisted_16 = {
  key: 1,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_17 = {
  key: 2,
  class: "p-3 bg-red-100 text-red-700 rounded-md mb-3"
}
const _hoisted_18 = { class: "flex justify-end space-x-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "bg-card rounded-lg shadow p-6 max-w-2xl mt-6" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-2",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_25 = {
  key: 1,
  class: "animate-spin h-5 w-5 mr-2",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "User Settings", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.userData?.avatar)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.userInitials), 1))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.userData.avatar,
                  alt: "User avatar",
                  class: "h-full w-full object-cover"
                }, null, 8, _hoisted_7))
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("button", {
            class: "absolute bottom-0 right-0 bg-primary text-primary-foreground rounded-full p-1 shadow-md hover:bg-primary/90 transition-colors",
            title: "Change avatar"
          }, [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "h-5 w-5",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
              }),
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M15 13a3 3 0 11-6 0 3 3 0 016 0z"
              })
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.userData?.name || 'User Name'), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.userData?.email || 'user@example.com'), 1)
        ])
      ]),
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent"])),
        class: "space-y-6"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "name",
              class: "block text-sm font-medium mb-1"
            }, "Full Name", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "Your full name"
            }, null, 512), [
              [_vModelText, _ctx.form.name]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              for: "email",
              class: "block text-sm font-medium mb-1"
            }, "Email Address", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "your.email@example.com"
            }, null, 512), [
              [_vModelText, _ctx.form.email]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "username",
              class: "block text-sm font-medium mb-1"
            }, "Username", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "username",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.username) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "username"
            }, null, 512), [
              [_vModelText, _ctx.form.username]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "system_role",
              class: "block text-sm font-medium mb-1"
            }, "System Role", -1)),
            _createElementVNode("input", {
              type: "text",
              id: "system_role",
              value: _ctx.formatSystemRole(_ctx.form.system_role as SystemRole),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary",
              placeholder: "Your system role",
              disabled: ""
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", null, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "business_role",
              class: "block text-sm font-medium mb-1"
            }, "Business Role", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "business_role",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.business_role) = $event)),
              class: "w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessRoles, (role) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: role,
                  value: role
                }, _toDisplayString(_ctx.formatBusinessRole(role)), 9, _hoisted_13))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.form.business_role]
            ])
          ])
        ]),
        (_ctx.successMessage || _ctx.error || _ctx.passwordError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.successMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.successMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.error.message), 1))
                : _createCommentVNode("", true),
              (_ctx.passwordError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.passwordError), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 border border-input rounded-md hover:bg-accent transition-colors",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "submit",
            class: "px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors",
            disabled: _ctx.loading
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Saving..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "Save Changes"))
          ], 8, _hoisted_19)
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Personal Data", -1)),
      _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Download a copy of your personal data stored in our system including your profile information and preferences ", -1)),
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.downloadPersonalData && _ctx.downloadPersonalData(...args))),
        class: "flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        disabled: _ctx.downloadLoading
      }, [
        (!_ctx.downloadLoading)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _cache[13] || (_cache[13] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("svg", _hoisted_25, _cache[14] || (_cache[14] = [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ]))),
        (_ctx.downloadLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Downloading..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_27, "Download My Data"))
      ], 8, _hoisted_23)
    ])
  ]))
}